export const jwtConstants = {
    secret: 'Shahiapi'
  };